<template>
  <div id="app">
    <router-view :key="$route.path"/>
    <el-backtop :visibility-height="400" :bottom="100"></el-backtop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>

.hd-right {
  width: calc(100% - 400px);
  overflow-x: auto;
  margin-left: 10px;
  overflow-y: hidden;
  display: flex;
  /* flex: none; */
  justify-content: space-around;
}

.navBar .hd-left {
  min-width: 273px;
}

::-webkit-scrollbar
{
    width:10%;
    height:0px;
    /* height: 2px; */
    /* background-color: #fff; */
    /* background-color: aquamarine; */
    border-radius:10px;
}
html,body {
  width: 100vw;
  height: 100%;
  margin: 0;
  padding: 0;
}

/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: "思源黑体 Medium";font-weight: 500;src: url("//at.alicdn.com/wf/webfont/83lGxJI9QniQ/G1LjW8k5aSfT.woff2") format("woff2"),
  url("//at.alicdn.com/wf/webfont/83lGxJI9QniQ/xodWujPGrorj.woff") format("woff");
  font-display: swap;
}

html {
  font-family: '思源黑体 Medium';
  font-size: 100%;
  color: #333;
  height: 100%;
}

@media screen and (max-width: 900px) {
  #hd {
    height: 60px!important;
  }
  #hd .hd_last {
    margin-right: 16px;
    width: 32px;
    height: 32px;
  }
  #hd .hd-left {
    flex: 1;
    justify-content: flex-start;
  }
  .titlefs {
    font-size: 24px!important;
  }
  .content-html {
    margin-left: 0px!important;
    width: 100%!important;
  }
}

.d_f {
  display: flex;
}
.d_f_sa {
  justify-content: space-around;
}
.d_f_sb {
  justify-content: space-between;
}
.w100 {
  width: 100%;
}
.content-html
thead,
.content-html tbody,
.content-html tfoot,
.content-html tr,
.content-html tbody td,
.content-html tbody th {
  border-width: 1px!important;
}
* {
  font-family: “Microsoft YaHei” ! important;
}
a {
  text-decoration: none!important;
  color: #333!important;
}
.c_p {
  cursor: pointer;
}

.t_d_n {
  text-decoration: none;
}
.fs18 {
  font-size: 18px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue